<template>
  <div>
    <div class="message-card-item" v-for="(card, index) in cardList" :key="index" @click="onClick(card)">
      <div class="message-card-row">
        <template v-if="card.url">
          <div class="message-card-left">
            <van-image :src="card.url.icon" width="88" height="88" fit="contain" class="disable-wechat-preview"/>
          </div>
          <div class="message-card-right">
            <div class="card-top">
              <div class="title ellipsis-2">{{card.url.productname}}</div>
            </div>
            <div class="card-bottom">
              <div class="title-sub ellipsis-1">{{card.url.exhibitorname}}</div>
              <div class="title-desc ellipsis-1">{{card.url.exhibitorboothno}}</div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="problemData.length">
      <CardProblem :data="problemData" @card-problem="onCardProblem" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CardProblem from './CardProblem'

  export default {
    name: "ExhibitCard",
    components: {
      CardProblem
    },
    props: {
      miniEnv: {
        type: Boolean,
        default: false
      },
      cardList: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...mapGetters(['tenantId']),
      problemData() {
        return this.cardList[this.cardList.length - 1].rec_problem_list || []
      }
    },
    methods: {
      onClick(card) {
        const id = card.url.product_id
        if (!id) {
          return
        }

        if (this.miniEnv) {
          if (this.tenantId === '244043'  || this.tenantId === '24404301') {
            // SIAL西雅
            wx.miniProgram.navigateTo({
              url: '/pages/exhibitors/exhibitorsGoodsDetails/exhibitorsGoodsDetail?id=' + id
            })
          } else {
            if (this.tenantId === '242290') {
              // 科博会
              wx.miniProgram.navigateTo({
                url: '/pages/webview/index?meta=' + JSON.stringify({ type: 'product_info', id })
              })
            } else if (this.tenantId === '470925') {
              // 面料
              wx.miniProgram.navigateTo({
                url: '/pages/webview/index?meta=' + JSON.stringify({ type: 'product_info', id })
              })
            } else {
              // 其他
              wx.miniProgram.navigateTo({
                url: '/pages/webview/index?meta=' + JSON.stringify({ type: 'product_info', id })
              })
            }
          }
        }
      },
      onCardProblem(problem) {
        this.$emit('card-problem', problem)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .message-card-item {
    padding: 12px 8px;
    box-sizing: border-box;
    margin-bottom: 8px;
    background: #FFFFFF;
    border-radius: 4px;
    position: relative;
    &:last-child{
      margin-bottom: 0;
    }
    .message-card-row {
      display: flex;
    }
    .message-card-left {
      width: 88px;
      height: 88px;
      border-radius: 4px;
      overflow: hidden;
      /deep/ img {
        pointer-events: none;       /* 禁止默认点击行为 */
        -webkit-touch-callout: none; /* 禁止长按菜单 */
      }

      .disable-wechat-preview img {
        pointer-events: none;        /* 阻止微信 WebView 默认放大 */
        -webkit-touch-callout: none; /* 禁止长按菜单 */
      }
    }
    .message-card-right {
      flex: 1;
      padding-left: 6px;
      box-sizing: border-box;
      min-width: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        font-weight: bold;
        font-size: 15px;
        line-height: 20px;
        color: rgba(0,0,0,0.85);
        margin-bottom: 4px;
      }
      .title-sub {
        font-weight: 400;
        font-size: 13px;
        color: rgba(0,0,0,0.45);
        line-height: 16px;
        margin-bottom: 4px;
      }
      .title-desc {
        font-weight: 400;
        font-size: 13px;
        color: rgba(0,0,0,0.65);
        line-height: 16px;
      }
    }
  }
</style>